(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mth-drops"] && !Shopify.designMode) return;
  try {
    
  class MthDropsScroller extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.mth-drops__scroller');
      if (!this.scroller) return;
      this.querySelectorAll('.mth-drops__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = parseInt(btn.dataset.dir, 10) || 1;
          this.scroller.scrollBy({ left: dir * this.scroller.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      this.updateOverflow();
      this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
      this.resizeObserver.observe(this.scroller);
    }
    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    updateOverflow() {
      const overflowing = this.scroller.scrollWidth > this.scroller.clientWidth + 4;
      this.classList.toggle('mth-drops__viewport--overflowing', overflowing);
    }
  }
  if (!customElements.get('mth-drops-scroller')) {
    customElements.define('mth-drops-scroller', MthDropsScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mth-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mth-home-reviews')) {
    customElements.define('mth-home-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const source = this.querySelector('[data-review-source]');
        const productSource = this.querySelector('[data-products]');
        this.track = this.querySelector('.mth-home-reviews__track');
        if (!source || !productSource || !this.track) return;
        const products = new Map();
        productSource.content.querySelectorAll('a[data-title]').forEach((product) => {
          if (product.dataset.available !== 'true') return;
          const key = product.dataset.title.trim().toLocaleLowerCase();
          products.set(key, products.has(key) ? null : product);
        });
        const groups = new Map();
        const seen = new Set();
        source.content.querySelectorAll('.jdgm-carousel-item').forEach((review) => {
          const id = review.dataset.reviewId;
          if (!id || seen.has(id) || review.classList.contains('jdgm--shop-review')) return;
          const image = review.querySelector('.jdgm-carousel-item__product-image');
          const product = products.get(image?.alt.trim().toLocaleLowerCase());
          const body = review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim();
          const name = review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim();
          const rating = review.querySelector('.jdgm-carousel-item__review-rating');
          const stars = rating?.querySelectorAll('.jdgm--on').length;
          if (!product || !body || !name || !stars || stars > 5) return;
          seen.add(id);
          if (!groups.has(product)) groups.set(product, []);
          groups.get(product).push({ id, body, name, stars, ratingLabel: rating.getAttribute('aria-label'), product });
        });
        const selected = [];
        const limit = Number(this.dataset.limit) || 5;
        while (selected.length < limit) {
          let added = false;
          for (const reviews of groups.values()) {
            if (!reviews.length) continue;
            selected.push(reviews.shift());
            added = true;
            if (selected.length === limit) break;
          }
          if (!added) break;
        }
        if (!selected.length) return;
        const element = (tag, className, text) => {
          const node = document.createElement(tag);
          if (className) node.className = className;
          if (text) node.textContent = text;
          return node;
        };
        selected.forEach((review, index) => {
          const card = element('li', 'mth-home-reviews__card');
          card.dataset.reviewId = review.id;
          const stars = element('div', 'mth-home-reviews__stars', '★'.repeat(review.stars) + '☆'.repeat(5 - review.stars));
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', review.ratingLabel);
          const quote = element('blockquote', 'mth-home-reviews__quote', review.body);
          quote.id = `${this.track.id}-quote-${index}`;
          quote.setAttribute('data-collapsed', '');
          const more = element('button', 'mth-home-reviews__more', this.dataset.moreLabel);
          more.type = 'button';
          more.hidden = true;
          more.setAttribute('aria-expanded', 'false');
          more.setAttribute('aria-controls', quote.id);
          more.addEventListener('click', () => {
            const expanded = more.getAttribute('aria-expanded') !== 'true';
            more.setAttribute('aria-expanded', String(expanded));
            quote.toggleAttribute('data-collapsed', !expanded);
            more.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
          }, { signal });
          const author = element('p', 'mth-home-reviews__author', review.name);
          const product = element('a', 'mth-home-reviews__product');
          product.href = review.product.getAttribute('href');
          if (review.product.dataset.image) {
            const image = element('img');
            image.src = review.product.dataset.image;
            image.alt = '';
            image.width = 64;
            image.height = 64;
            image.loading = 'lazy';
            product.append(image);
          }
          const productText = element('span');
          productText.append(element('strong', '', review.product.dataset.title), element('small', '', this.dataset.shopLabel));
          product.append(productText);
          card.append(stars, quote, more, author, product);
          this.track.append(card);
        });
        this.hidden = false;
        document.querySelectorAll('[data-home-review-jump]').forEach((link) => { link.hidden = false; });
        document.addEventListener('shopify:section:load', (event) => {
          event.target.querySelectorAll('[data-home-review-jump]').forEach((link) => { link.hidden = false; });
        }, { signal });
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.position = this.querySelector('.mth-home-reviews__position');
        const move = (direction) => {
          const cards = [...this.track.children];
          const current = cards.reduce((best, card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - this.track.getBoundingClientRect().left);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity }).index;
          const target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
          this.track.scrollBy({ left: target.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.querySelectorAll('[data-direction]').forEach((button) => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth });
          else move(event.key === 'ArrowLeft' ? -1 : 1);
        }, { signal });
        this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.observer = new ResizeObserver(() => {
          this.updateNavigation();
          this.track.querySelectorAll('.mth-home-reviews__quote').forEach((quote) => {
            const button = quote.nextElementSibling;
            if (button.getAttribute('aria-expanded') !== 'true') button.hidden = quote.scrollHeight <= quote.clientHeight + 1;
          });
        });
        this.observer.observe(this.track);
        this.updateNavigation();
      }
      updateNavigation() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 4;
        this.querySelector('.mth-home-reviews__navigation').hidden = !overflow;
        this.previous.disabled = this.track.scrollLeft < 4;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        const bounds = this.track.getBoundingClientRect();
        const visible = [...this.track.children].map((card, index) => ({ bounds: card.getBoundingClientRect(), index })).filter((card) => card.bounds.left >= bounds.left - 4 && card.bounds.right <= bounds.right + 4);
        if (!visible.length) return;
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        this.position.textContent = this.dataset.positionLabel.replace('[range]', first === last ? String(first) : `${first}–${last}`).replace('[total]', this.track.children.length);
      }
      disconnectedCallback() {
        document.querySelectorAll('[data-home-review-jump]').forEach((link) => { link.hidden = true; });
        this.controller?.abort();
        this.observer?.disconnect();
        this.track?.replaceChildren();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mth-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  class MthReelsScroller extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const listenerOptions = { signal: this.abortController.signal };
      this.videos = Array.from(this.querySelectorAll('video'));
      this.initDialogs(listenerOptions);
      this.initWholesaleLinks(listenerOptions);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!this.videos.length) return;
      this.visibleVideos = new Set();

      this.videos.forEach((video) => {
        const clipStart = parseFloat(video.dataset.clipStart) || 0;
        const clipEnd = parseFloat(video.dataset.clipEnd) || 0;
        video.addEventListener('playing', () => video.classList.add('is-playing'), listenerOptions);
        video.addEventListener('pause', () => video.classList.remove('is-playing'), listenerOptions);
        if (clipStart > 0) {
          video.addEventListener('loadedmetadata', () => {
            try { video.currentTime = clipStart; } catch (e) {}
          }, listenerOptions);
        }
        if (clipStart > 0 || clipEnd > 0) {
          video.addEventListener('timeupdate', () => {
            if (clipEnd > 0 && video.currentTime >= clipEnd) {
              try { video.currentTime = clipStart; } catch (e) {}
            }
          }, listenerOptions);
        }
      });

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          if (visible) {
            this.visibleVideos.add(video);
            if (!document.hidden) this.playVideo(video);
          } else {
            this.visibleVideos.delete(video);
            this.pauseVideo(video);
          }
        });
      }, { threshold: [0, 0.35] });
      this.videos.forEach((video) => this.videoObserver.observe(video));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.videos.forEach((video) => this.pauseVideo(video));
        } else {
          this.visibleVideos.forEach((video) => this.playVideo(video));
        }
      }, listenerOptions);

    }
    initDialogs(listenerOptions) {
      this.querySelectorAll('[data-reel-dialog-open]').forEach((button) => {
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (!dialog) return;
        button.addEventListener('click', () => {
          this.videos?.forEach((video) => this.pauseVideo(video));
          dialog.showModal();
        }, listenerOptions);
        dialog.querySelector('[data-reel-dialog-close]')?.addEventListener('click', () => dialog.close(), listenerOptions);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        }, listenerOptions);
        dialog.addEventListener('close', () => {
          if (!document.hidden) this.visibleVideos?.forEach((video) => this.playVideo(video));
          button.focus();
        }, listenerOptions);
      });
    }
    initWholesaleLinks(listenerOptions) {
      this.querySelectorAll('[data-wholesale-reel-product-link]').forEach((link) => {
        link.addEventListener('click', () => {
          const dialog = link.closest('dialog');
          if (dialog?.open) dialog.close();
        }, listenerOptions);
      });
    }
    disconnectedCallback() {
      this.videoObserver?.disconnect();
      this.abortController?.abort();
      this.videos?.forEach((video) => video.pause());
      this.visibleVideos?.clear();
    }
    playVideo(video) {
      video.play().catch(() => {});
    }
    pauseVideo(video) {
      video.pause();
      video.classList.remove('is-playing');
    }
  }
  if (!customElements.get('mth-reels-scroller')) {
    customElements.define('mth-reels-scroller', MthReelsScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mth-styled-on"] && !Shopify.designMode) return;
  try {
    
  /* Count-up for the brand-stats numbers: the final value is server-rendered;
     when the row first scrolls into view we rewind to 0 and ease up to the
     target over ~1.4s (Twitter-style "it is growing" effect). Reduced-motion
     visitors keep the static server-rendered numbers. ASCII ONLY in this
     block - non-ASCII truncates the theme-dev scripts.js bundle. */
  class MthIgStats extends HTMLElement {
    connectedCallback() {
      this.numbers = Array.from(this.querySelectorAll('[data-target]'));
      if (!this.numbers.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.disconnect();
            this.observer = null;
            this.countUp();
          });
        },
        { threshold: 0.6 }
      );
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    format(value) {
      if (value >= 1000000) return (Math.floor(value / 100000) / 10).toFixed(1).replace(/\.0$/, '') + 'M';
      if (value >= 10000) return (Math.floor(value / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'K';
      return Math.round(value).toLocaleString('en-US');
    }
    countUp() {
      const duration = 1400;
      const targets = this.numbers.map((el) => parseInt(el.dataset.target, 10) || 0);
      const start = performance.now();
      const step = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        this.numbers.forEach((el, i) => {
          el.textContent = this.format(targets[i] * eased);
        });
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }
  if (!customElements.get('mth-ig-stats')) {
    customElements.define('mth-ig-stats', MthIgStats);
  }

  class MthStyledMarquee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.interactive !== 'true') return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.resumeDelay = 3000;
      this.dragged = false;

      this.addEventListener('pointerdown', (event) => this.startDrag(event), options);
      this.addEventListener('pointermove', (event) => this.drag(event), options);
      this.addEventListener('pointerup', (event) => this.endDrag(event), options);
      this.addEventListener('pointercancel', (event) => this.endDrag(event), options);
      this.addEventListener('wheel', () => this.pauseTemporarily(), { ...options, passive: true });
      this.addEventListener('touchstart', () => this.pauseTemporarily(), { ...options, passive: true });
      this.addEventListener('scroll', () => this.pauseTemporarily(), { ...options, passive: true });
      this.addEventListener('keydown', (event) => this.handleKeydown(event), options);
      this.addEventListener('click', (event) => {
        if (!this.dragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragged = false;
      }, { ...options, capture: true });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      window.clearTimeout(this.resumeTimer);
    }
    pauseTemporarily() {
      this.classList.add('is-paused');
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.classList.remove('is-paused'), this.resumeDelay);
    }
    startDrag(event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.scrollLeft;
      this.dragged = false;
      this.classList.add('is-dragging');
      this.setPointerCapture?.(event.pointerId);
      this.pauseTemporarily();
    }
    drag(event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerId !== this.pointerId) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 5) this.dragged = true;
      this.scrollLeft = this.startScrollLeft - distance;
      this.pauseTemporarily();
    }
    endDrag(event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerId !== this.pointerId) return;
      this.releasePointerCapture?.(event.pointerId);
      this.pointerId = null;
      this.classList.remove('is-dragging');
      this.pauseTemporarily();
    }
    handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.scrollBy({ left: event.key === 'ArrowRight' ? 240 : -240, behavior: 'smooth' });
      this.pauseTemporarily();
    }
  }
  if (!customElements.get('mth-styled-marquee')) {
    customElements.define('mth-styled-marquee', MthStyledMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speedway-dice-upsell"]) return;
  try {
    
  (() => {
    const cartAttribute = 'mth_game_offer_seen__';
    const pendingKey = 'mth_game_offer_pending';

    const init = (dialog) => {
      if (!dialog || dialog.dataset.upsellInitialized === 'true') return;
      dialog.dataset.upsellInitialized = 'true';

      const configElement = dialog.querySelector('[data-upsell-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const campaignKey = String(config.campaignKey || 'free-keyloop-21-challenge-v1');
      const storageKey = `mth_game_offer_seen_${campaignKey}`;
      const panels = Array.from(dialog.querySelectorAll('[data-upsell-panel]'));
      const gamePanel = dialog.querySelector('[data-upsell-panel="game"]');
      const title = dialog.querySelector('[data-upsell-title]');
      const body = dialog.querySelector('[data-upsell-body]');
      const status = dialog.querySelector('[data-upsell-status]');
      const errorMessage = dialog.querySelector('[data-upsell-error]');
      const cardGame = dialog.querySelector('[data-upsell-card-game]');
      const mthDrawCard = dialog.querySelector('[data-upsell-mth-draw-card]');
      const yourDrawCard = dialog.querySelector('[data-upsell-your-draw-card]');
      const mthTotal = dialog.querySelector('[data-upsell-mth-total]');
      const yourTotal = dialog.querySelector('[data-upsell-your-total]');
      const standButton = dialog.querySelector('[data-upsell-stand]');
      const hitButton = dialog.querySelector('[data-upsell-hit]');
      const retryButton = dialog.querySelector('[data-upsell-retry]');
      const addOfferButton = dialog.querySelector('[data-upsell-add-offer]');
      const closeButton = dialog.querySelector('[data-upsell-close]');
      const keepButton = dialog.querySelector('[data-upsell-keep]');
      const forfeitButton = dialog.querySelector('[data-upsell-forfeit]');
      const successMessage = dialog.querySelector('[data-upsell-success-message]');
      const variantInput = dialog.querySelector('[data-upsell-variant]');
      const targetVariantIds = (config.variantIds || []).map(Number);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let isShown = false;
      let isChecking = false;
      let canCloseWithoutWarning = false;
      let isResolvingMove = false;
      let lastFocusedElement = null;

      const suspenseDelay = (duration) => new Promise((resolve) => {
        window.setTimeout(resolve, reducedMotion ? Math.min(duration, 120) : duration);
      });

      const setStatus = (message, isBuilding = false) => {
        status.textContent = message;
        status.classList.toggle('is-building-suspense', isBuilding);
      };

      const readLocalSeen = () => {
        try {
          return window.localStorage.getItem(storageKey) === campaignKey;
        } catch (error) {
          return false;
        }
      };

      const writeLocalSeen = () => {
        try {
          window.localStorage.setItem(storageKey, campaignKey);
        } catch (error) {
          return;
        }
      };

      const writeCartSeen = () => {
        fetch(config.routes.update, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ attributes: { [cartAttribute]: campaignKey } })
        }).catch(() => {});
      };

      const markSeen = () => {
        writeLocalSeen();
        writeCartSeen();
      };

      const setPanel = (name) => {
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.upsellPanel !== name;
        });
        const activePanel = panels.find((panel) => panel.dataset.upsellPanel === name);
        const activeTitle = activePanel && activePanel.querySelector('.SpeedwayDiceUpsell__Title[id]');
        const activeBody = activePanel && activePanel.querySelector('.SpeedwayDiceUpsell__Body[id]');
        if (activeTitle) dialog.setAttribute('aria-labelledby', activeTitle.id);
        if (activeBody) dialog.setAttribute('aria-describedby', activeBody.id);
      };

      const focusGameAction = () => {
        const candidates = [addOfferButton, retryButton, standButton, hitButton];
        const target = candidates.find((button) => button && !button.hidden && !button.disabled);
        if (target) target.focus();
      };

      const openOffer = () => {
        if (isShown || readLocalSeen()) return;
        isShown = true;
        lastFocusedElement = document.activeElement;
        markSeen();
        setPanel('game');
        document.body.classList.add('SpeedwayDiceUpsellOpen');
        dialog.showModal();
        window.setTimeout(() => standButton.focus(), 40);
      };

      const closeOffer = () => {
        if (!dialog.open) return;
        dialog.close();
        document.body.classList.remove('SpeedwayDiceUpsellOpen');
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      };

      const showCloseConfirmation = () => {
        if (canCloseWithoutWarning) {
          closeOffer();
          return;
        }
        setPanel('confirm');
        window.setTimeout(() => keepButton.focus(), 20);
      };

      const cartContainsTarget = (cart) => {
        return Boolean(cart && Array.isArray(cart.items) && cart.items.some((item) => Number(item.product_id) === Number(config.productId)));
      };

      const cartHasSeenCampaign = (cart) => {
        return Boolean(cart && cart.attributes && cart.attributes[cartAttribute] === campaignKey);
      };

      const fetchCart = () => fetch(config.routes.cart, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then((response) => response.ok ? response.json() : Promise.reject(response));

      const checkAndOpen = () => {
        if (isChecking || isShown || readLocalSeen()) return;
        isChecking = true;
        fetchCart()
          .then((cart) => {
            if (cartHasSeenCampaign(cart)) {
              writeLocalSeen();
              return;
            }
            if (!cartContainsTarget(cart)) openOffer();
          })
          .catch(() => openOffer())
          .finally(() => {
            isChecking = false;
          });
      };

      const isTargetAddition = (variant) => {
        if (!variant) return false;
        if (Number(variant.product_id) === Number(config.productId)) return true;
        const variantId = Number(variant.variant_id || variant.id);
        return targetVariantIds.includes(variantId);
      };

      const isTargetVariantId = (variantId) => targetVariantIds.includes(Number(variantId));

      const handleSuccessfulAdd = (variantId) => {
        try {
          window.sessionStorage.removeItem(pendingKey);
        } catch (error) {}
        if (!isTargetVariantId(variantId)) checkAndOpen();
      };

      const showWin = () => {
        cardGame.dataset.stage = 'win';
        setStatus('');
        title.textContent = config.copy.winTitle;
        body.textContent = config.copy.winBody;
        standButton.hidden = true;
        hitButton.hidden = true;
        addOfferButton.hidden = false;
        addOfferButton.focus();
      };

      const showHitResult = () => {
        cardGame.dataset.stage = 'loss';
        setStatus('');
        title.textContent = config.copy.hitTitle;
        body.textContent = config.copy.hitBody;
        standButton.hidden = true;
        hitButton.hidden = true;
        retryButton.hidden = false;
        retryButton.focus();
      };

      const resetHand = () => {
        isResolvingMove = false;
        cardGame.dataset.stage = 'ready';
        mthDrawCard.classList.remove('is-drawing', 'is-revealed');
        yourDrawCard.classList.remove('is-drawing', 'is-revealed');
        mthDrawCard.setAttribute('aria-label', config.copy.mthDrawHidden);
        yourDrawCard.setAttribute('aria-label', config.copy.yourDrawHidden);
        mthTotal.textContent = '16';
        yourTotal.textContent = '18';
        title.textContent = config.copy.gameTitle;
        body.textContent = config.copy.gameBody;
        standButton.hidden = false;
        standButton.disabled = false;
        hitButton.hidden = false;
        hitButton.disabled = false;
        retryButton.hidden = true;
        addOfferButton.hidden = true;
        setStatus(config.copy.ready);
        standButton.focus();
      };

      const setAdding = (button, isAdding) => {
        button.disabled = isAdding;
        if (isAdding) {
          button.dataset.originalText = button.textContent;
          button.textContent = config.copy.adding;
        } else if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
        }
      };

      const selectedVariantId = () => Number(variantInput && variantInput.value);

      const offerTag = (offerType) => `${offerType}:${campaignKey}`;

      const addLineItem = (offerType) => fetch(config.routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: selectedVariantId(),
          quantity: 1,
          properties: { _mth_game_offer: offerTag(offerType) }
        })
      }).then((response) => response.ok ? response.json() : Promise.reject(response));

      const applyDiscount = () => {
        if (!config.discountCode) return Promise.reject(new Error('missing_discount_code'));
        return fetch(config.routes.update, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ discount: config.discountCode })
        }).then((response) => response.ok ? response.json() : Promise.reject(response));
      };

      const removeLineItem = (lineKey) => fetch(config.routes.change, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(() => {});

      const findOfferLine = (cart, offerType) => cart.items.find((item) => {
        const properties = item.properties || {};
        return Number(item.variant_id) === selectedVariantId()
          && properties._mth_game_offer === offerTag(offerType);
      });

      const removeOfferLine = (offerType, fallbackKey) => fetchCart()
        .then((cart) => {
          const line = findOfferLine(cart, offerType);
          return removeLineItem(line ? line.key : fallbackKey);
        })
        .catch(() => removeLineItem(fallbackKey));

      const verifyOfferPrice = (offerType, attempt = 0) => fetchCart().then((cart) => {
        const line = findOfferLine(cart, offerType);
        if (line && Number(line.final_price) === Number(config.offerPriceCents)) return cart;
        if (attempt >= 3) return Promise.reject(new Error('offer_price_not_applied'));
        return new Promise((resolve) => window.setTimeout(resolve, 350)).then(() => verifyOfferPrice(offerType, attempt + 1));
      });

      const notifyCartUpdated = () => {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mth-21-challenge-upsell' });
        }

        fetch(`${config.routes.cartPage}?section_id=cart-icon-bubble`, { credentials: 'same-origin' })
          .then((response) => response.ok ? response.text() : Promise.reject(response))
          .then((html) => {
            const currentBubble = document.getElementById('cart-icon-bubble');
            const nextBubble = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
            if (currentBubble && nextBubble) currentBubble.replaceWith(nextBubble);
          })
          .catch(() => {});
      };

      const showSuccess = (message) => {
        canCloseWithoutWarning = true;
        successMessage.textContent = message;
        setPanel('success');
        notifyCartUpdated();
        window.setTimeout(() => {
          const cartLink = dialog.querySelector('[data-upsell-panel="success"] a');
          if (cartLink) cartLink.focus();
        }, 20);
      };

      const showError = (message) => {
        errorMessage.textContent = message;
        errorMessage.hidden = false;
      };

      const addWinnerOffer = () => {
        errorMessage.hidden = true;
        setAdding(addOfferButton, true);
        let addedLine;
        addLineItem('winner')
          .then((line) => {
            addedLine = line;
            return applyDiscount();
          })
          .then(() => verifyOfferPrice('winner'))
          .then(() => showSuccess(config.copy.successOffer))
          .catch(() => {
            const cleanup = addedLine && addedLine.key ? removeOfferLine('winner', addedLine.key) : Promise.resolve();
            cleanup.then(() => {
              notifyCartUpdated();
              showError(config.copy.errorOffer);
            });
          })
          .finally(() => setAdding(addOfferButton, false));
      };

      standButton.addEventListener('click', () => {
        if (isResolvingMove) return;
        isResolvingMove = true;
        standButton.disabled = true;
        hitButton.disabled = true;
        cardGame.dataset.stage = 'drawing';
        mthDrawCard.classList.add('is-drawing');
        setStatus(config.copy.drawingMth, true);
        suspenseDelay(760)
          .then(() => {
            mthDrawCard.classList.add('is-revealed');
            mthDrawCard.setAttribute('aria-label', config.copy.mthDrawnCard);
            mthTotal.textContent = '24';
            setStatus(config.copy.checkingResult, true);
            return suspenseDelay(900);
          })
          .then(showWin);
      });

      hitButton.addEventListener('click', () => {
        if (isResolvingMove) return;
        isResolvingMove = true;
        standButton.disabled = true;
        hitButton.disabled = true;
        cardGame.dataset.stage = 'drawing';
        yourDrawCard.classList.add('is-drawing');
        setStatus(config.copy.drawingYou, true);
        suspenseDelay(760)
          .then(() => {
            yourDrawCard.classList.add('is-revealed');
            yourDrawCard.setAttribute('aria-label', config.copy.yourDrawnCard);
            yourTotal.textContent = '25';
            setStatus(config.copy.checkingResult, true);
            return suspenseDelay(900);
          })
          .then(showHitResult);
      });

      retryButton.addEventListener('click', resetHand);

      addOfferButton.addEventListener('click', addWinnerOffer);
      closeButton.addEventListener('click', showCloseConfirmation);
      keepButton.addEventListener('click', () => {
        setPanel('game');
        window.setTimeout(focusGameAction, 20);
      });
      forfeitButton.addEventListener('click', closeOffer);

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        showCloseConfirmation();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) showCloseConfirmation();
      });

      document.addEventListener('product:added', (event) => {
        const variant = event.detail && event.detail.variant;
        try {
          window.sessionStorage.removeItem(pendingKey);
        } catch (error) {}
        if (!isTargetAddition(variant)) checkAndOpen();
      });

      const subscribeToProductAdds = (attempt = 0) => {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event && event.source === 'product-form') {
              handleSuccessfulAdd(event.productVariantId);
            }
          });
          return;
        }
        if (attempt < 50) window.setTimeout(() => subscribeToProductAdds(attempt + 1), 100);
      };

      subscribeToProductAdds();

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = form.getAttribute('action') || '';
        if (!action.includes('/cart/add')) return;
        const idInput = form.querySelector('[name="id"]');
        const variantId = Number(idInput && idInput.value);
        if (!variantId || targetVariantIds.includes(variantId)) return;
        try {
          window.sessionStorage.setItem(pendingKey, JSON.stringify({ variantId, time: Date.now() }));
        } catch (error) {
          return;
        }
      }, true);

      try {
        const pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null');
        if (pending && Date.now() - Number(pending.time) < 120000 && !targetVariantIds.includes(Number(pending.variantId))) {
          window.sessionStorage.removeItem(pendingKey);
          window.setTimeout(checkAndOpen, 250);
        }
      } catch (error) {
        window.sessionStorage.removeItem(pendingKey);
      }
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-speedway-upsell]')) init(scope);
      scope.querySelectorAll('[data-speedway-upsell]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
